export default __webpack_public_path__ + "resources/icons/d331-2868.png";